<template>
    <div id="address-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                :placeholder="$t('message.address')"
                v-model="fieldAddress"
                @input="setFieldLabelAddress(fieldAddress)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: align === 'left' }" @click="setLabelAlignAddress('left')">{{ $t("form.left") }}</button>
                <button class="button" :class="{ active: align === 'right' }" @click="setLabelAlignAddress('right')">{{ $t("form.right") }}</button>
                <button class="button" :class="{ active: align === 'top' }" @click="setLabelAlignAddress('top')">{{ $t("form.top") }}</button>
            </div>
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.required") }}</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ requiredText }}</span>
            </div>
            <small class="form-description">{{ $t("form.fieldEmptyError") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: visibility }"
                      @click="toggleVisibility">{{ visibility ? "Görünür" : "Gizli" }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="address"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.subLabels") }}</label>
            <div class="sub-labels">
                <div class="sub-label-item">
                    <label for="address-line-1" class="sub-label">{{ $t("form.addressLine1") }}</label>
                    <input
                        type="text"
                        id="address-line-1"
                        class="sub-label-input"
                        :placeholder="$t('form.addressLine1')"
                        v-model="addressLine1"
                        @input="setFieldAddressLine1(addressLine1)"
                    >
                </div>
                <div class="sub-label-item">
                    <label for="address-line-2" class="sub-label">{{ $t("form.addressLine2") }}</label>
                    <input
                        type="text"
                        id="address-line-2"
                        class="sub-label-input"
                        :placeholder="$t('form.addressLine2')"
                        v-model="addressLine2"
                        @input="setFieldAddressLine2(addressLine2)"
                    >
                </div>
                <div class="sub-label-item">
                    <label for="district" class="sub-label">{{ $t("akinon.city") }}</label>
                    <input
                        type="text"
                        id="district"
                        class="sub-label-input"
                        :placeholder="$t('akinon.city')"
                        v-model="district"
                        @input="setFieldDistrict(district)"
                    >
                </div>
                <div class="sub-label-item">
                    <label for="postal-code" class="sub-label">{{ $t("form.postalCode") }}</label>
                    <input
                        type="text"
                        id="postal-code"
                        class="sub-label-input"
                        :placeholder="$t('form.postalCode')"
                        v-model="postalCode"
                        @input="setFieldPostalCode(postalCode)"
                    >
                </div>
                <div class="sub-label-item">
                    <label for="state" class="sub-label">{{ $t("form.stateProvince") }}</label>
                    <input
                        type="text"
                        id="state"
                        class="sub-label-input"
                        :placeholder="$t('form.stateProvince')"
                        v-model="state"
                        @input="setFieldState(state)"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: 'AddressSettings',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldAddress: this.item.address.fieldAddress,
            align: this.item.address.align,
            addressLine1: this.item.address.addressLine1,
            addressLine2: this.item.address.addressLine2,
            district: this.item.address.district,
            postalCode: this.item.address.postalCode,
            state: this.item.address.state,
            isRequired: this.item.address.isRequired,
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            defaultAlign: false,
            updateTimer: null,
        };
    },
    computed: {
        requiredText() {
            return this.isRequired ? this.$t("chatWindow.open") : this.$t("chatWindow.closed");
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setLabelAlignAddress(align) {
            this.align = align;
            this.updateFields();
            this.$emit("update-label-align-address", align);
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.updateFields();
            this.$emit("update-required", this.isRequired);
        },
        setFieldLabelAddress(label) {
            this.fieldAddress = label;
            this.$emit("update-field-label-address", label);
            this.updateFields();
        },
        setFieldAddressLine1(addressLine1) {
            this.addressLine1 = addressLine1;
            this.$emit("update-field-address-line-1", addressLine1);
            this.updateFields();
        },
        setFieldAddressLine2(addressLine2) {
            this.addressLine2 = addressLine2;
            this.$emit("update-field-address-line-2", addressLine2);
            this.updateFields();
        },
        setFieldDistrict(district) {
            this.district = district;
            this.$emit("update-field-district", district);
            this.updateFields();
        },
        setFieldPostalCode(postalCode) {
            this.postalCode = postalCode;
            this.$emit("update-field-postal-code", postalCode);
            this.updateFields();
        },
        setFieldState(state) {
            this.state = state;
            this.$emit("update-field-state", state);
            this.updateFields();
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateFields();
            this.$emit("update-visibility", this.visibility);
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.$emit("update-slug", this.slug);
            this.updateFields();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateFields() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    visibility: self.visibility,
                    slug: self.slug,
                    address: {
                        fieldAddress: self.fieldAddress,
                        align: self.align,
                        addressLine1: self.addressLine1,
                        addressLine2: self.addressLine2,
                        district: self.district,
                        postalCode: self.postalCode,
                        state: self.state,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.address) { return; }
                this.fieldAddress = val.address.fieldAddress;
                this.align = val.address.align;
                this.addressLine1 = val.address.addressLine1;
                this.addressLine2 = val.address.addressLine2;
                this.district = val.address.district;
                this.postalCode = val.address.postalCode;
                this.state = val.address.state;
                this.isRequired = val.address.isRequired;
                this.visibility = typeof val.visibility !== 'undefined' ? val.visibility : this.visibility;
                this.slug = val.slug || '';
            },
            deep: true,
            immediate: false,
        },
        'item.address.fieldAddress': function (newVal) {
            this.fieldAddress = newVal;
        },
        'item.address.align': function (newVal) {
            this.align = newVal;
        },
        'item.address.addressLine1': function (newVal) {
            this.addressLine1 = newVal;
        },
        'item.address.addressLine2': function (newVal) {
            this.addressLine2 = newVal;
        },
        'item.address.district': function (newVal) {
            this.district = newVal;
        },
        'item.address.postalCode': function (newVal) {
            this.postalCode = newVal;
        },
        'item.address.state': function (newVal) {
            this.state = newVal;
        },
        'item.address.isRequired': function (newVal) {
            this.isRequired = newVal;
        },
        'item.visibility': function (newVal) {
            this.visibility = newVal;
        },
        'item.slug': function (newVal) {
            this.slug = newVal || '';
        },
    },
};
</script>

<style lang="scss" scoped>
#address-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #059669;
                    color: #ffffff;
                    border-color: #059669;
                    box-shadow: 0 1px 3px rgba(5, 150, 105, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .sub-labels {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .sub-label-item {
                display: flex;
                flex-direction: column;

                .sub-label {
                    font-weight: 600;
                    color: #374151;
                    margin-bottom: 4px;
                    font-size: 0.8rem;
                }

                .sub-label-input {
                    padding: 6px 10px;
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    background-color: #ffffff;
                    color: #374151;
                    font-size: 0.8rem;
                    transition: border-color 0.2s ease, box-shadow 0.2s ease;

                    &:focus {
                        outline: none;
                        border-color: #64748b;
                        box-shadow: 0 0 0 2px rgba(100, 116, 139, 0.1);
                    }

                    &::placeholder {
                        color: #9ca3af;
                    }
                }
            }
        }
    }
}
</style>
